"use client";

import defaultTheme from "tailwindcss/defaultTheme";
import { AppMediaQueryBreakpoints, DeviceType } from "@/interfaces";
import useBreakpoint from "./useBreakpoint";

export function useAppMediaQuery(
  userAgent?: DeviceType,
): AppMediaQueryBreakpoints {
  if (window === undefined) {
    return {
      activeBreakpoint: "2xl",
      is2xlScreen: true,
      isXlScreen: true,
      isLgScreen: true,
      isMdScreen: false,
      isSmScreen: false,
      isXsScreen: false,
      isWideScreen: false,
      isNarrowScreen: false,
    };
  }
  const xs = useBreakpoint(`(min-width:0px)`);
  const sm = useBreakpoint(`(min-width: ${defaultTheme.screens.sm})`);
  const md = useBreakpoint(`(min-width: ${defaultTheme.screens.md})`);
  const lg = useBreakpoint(`(min-width: ${defaultTheme.screens.lg})`);
  const xl = useBreakpoint(`(min-width: ${defaultTheme.screens.xl})`);
  const xxl = useBreakpoint(`(min-width: ${defaultTheme.screens["2xl"]})`);

  const breakpoints = {
    "2xl": xxl,
    xl,
    lg,
    md,
    sm,
    xs,
  };

  const active = breakpoints["2xl"]
    ? "2xl"
    : breakpoints.xl
      ? "xl"
      : breakpoints.lg
        ? "lg"
        : breakpoints.md
          ? "md"
          : breakpoints.sm
            ? "sm"
            : "xs";

  return {
    activeBreakpoint: active,
    is2xlScreen: active === "2xl",
    isXlScreen: active === "xl",
    isLgScreen: active === "lg",
    isMdScreen: active === "md",
    isSmScreen: active === "sm",
    isXsScreen: active === "xs",
    isWideScreen: ["lg", "xl", "2xl"].includes(active),
    isNarrowScreen: ["xs", "sm", "md"].includes(active),
  };
}
